<template>
<ControlUnit
    :title="$t('control.panel.widget_titles')"
    :tooltip="$t('control.panel.widget_titles_description')"
  >
    <div class="input-input">
    <label class="input-input__unit">
      <span class="input-input__label">{{ $t('control.panel.title_parameter') }}:</span>

      <input
        class="input-input__input"
        type="text"
        name="title-parameter"
        v-model="currentTitle"
      >

    </label>

    </div>

   <div class="input-input">
    <label class="input-input__unit">
      <span class="input-input__label">{{ $t('control.panel.sub_title_parameter') }}:</span>

      <input
        class="input-input__input"
        type="text"
        name="sub-title-parameter"
        v-model="currentSubTitle"
      >
    </label>
    </div>

</ControlUnit>

</template>

<script>
import useStateController from './useStateController';
import ControlUnit from "@/views/Control/ControlPanel/ControlUnit/ControlUnit";
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
import useRouteController from "@/views/Control/ControlPanel/ControlUnit/useRouteController";
import {runAllWithData} from "@/helpers/functional";


export default {
  components: {
    ControlUnit,
  },


  setup() {

    const titleName = 'title-parameter';
    const subtitleName = 'subtitle-parameter';
    const store = useStore();

    const currentTitle = computed({
      get() {
        return store.state.control.currentTitle;
      }, set(val){
          changeHandler({
            type: titleName,
            value: val,
        })
      }
    });

    const currentSubTitle = computed({
      get() {
        return store.state.control.currentSubTitle;
      }, set(val){
          changeHandler({
            type: subtitleName,
            value: val,
        })
      }
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {

      changeControlHandler({
        type: titleName,
        value: getRouterQueryValue(titleName),
      });

      changeControlHandler({
        type: subtitleName,
        value: getRouterQueryValue(subtitleName),
      });
    });

    return {
      titleName,
      subtitleName,
      currentTitle,
      currentSubTitle,
      changeHandler,
    };
  },
};
</script>
